module.exports = __webpack_public_path__ + "img/antes_despues_106.9583cb3a.png";